var ChartsPlugin = require('utils/charts/charts_plugin');
var ChartsZoomLimit = ChartsPlugin.extend({
    initPlugin: function () {
        var self = this;
        this.chartView.on('charts:draw:after', function () {
            self.foreachCharts(function (key, value) {
                this.onDrawCallback(value, false);
            });
        });
    },

    onDrawCallback: function (g, is_initial) {
        this.limitZoom();
    },

    limitZoom: function () {
        var valueWindows = {};
        var isChanged = false;

        this.foreachCharts(function (id, g) {
            var valueWindow = this.getValueWindow(g);
            var minValue = valueWindow[0] * Math.pow(2, -50);
            if (valueWindow[1] - valueWindow[0] <= minValue) {
                m = (valueWindow[1] + valueWindow[0]) / 2;
                valueWindow[0] = m - minValue;
                valueWindow[1] = m + minValue;
                isChanged = true;
            }

            var attempts = 10000;
            while (!this.checkTicks(valueWindow, id, g) && attempts > 0) {
                valueWindow = this.expandWindow(valueWindow);
                isChanged = true;
                attempts--;
            }

            valueWindows[id] = valueWindow;
        });

        var isChangedTime = false;
        var minTimeWindow = 300000;
        var currentDateWindow = this.getDateWindow();
        var timeDiff = currentDateWindow[1] - currentDateWindow[0];
        if (timeDiff < minTimeWindow) {
            var center = (currentDateWindow[1] + currentDateWindow[0]) / 2;
            currentDateWindow = [center - minTimeWindow / 2, center + minTimeWindow / 2];
            isChangedTime = true;
        }

        if (isChanged || isChangedTime) {
            this.chartView.updateOptions(
                currentDateWindow[0],
                currentDateWindow[1],
                true,
                true,
                valueWindows,
                false,
                true
            );
        }
    },

    expandWindow: function (r) {
        var center = (r[1] + r[0]) / 2;
        var range = (r[1] - r[0]) / 2;
        range = range * 1.1;
        r = [center - range, center + range];
        return r;
    },

    checkTicks: function (valueWindow, id, g) {
        var center = (valueWindow[0] + valueWindow[1]) / 2;
        var range = (valueWindow[1] - valueWindow[0]) / 1.1;
        var ticks = {};
        for (var x = center - range / 2; x <= center + range / 2; x += range / 10) {
            var tick = this.chartView.getChartTickValue(x, id, g);
            if (ticks[tick]) {
                return false;
            }
            ticks[tick] = true;
        }
        return true;
    },
});

module.exports = ChartsZoomLimit;
